import React from 'react'

import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper'
import { INTERVENER_CODES } from 'constants/interveners'
import {DepositInterveners} from './depositInterveners'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
import { i18n } from 'core/i18n';
import { getLastNChars } from 'utilities/stringHelper'
import { formatInterest } from 'utilities/currencyHelper'
import { getIsFullProfitability } from 'utilities/depositHelper'


const CONTACT_CENTER_POE_KEYS = {
    cancelInfo: 'contractsView-contractsView_ccDepositConditionCancelInfo',
    product: 'contractsView-contractsView_ccDepositConditionProduct',
    time: 'contractsView-contractsView_ccDepositConditionTime',
    amount: 'contractsView-contractsView_ccDepositConditionAmount',
    profitability: 'contractsView-contractsView_ccDepositConditionProfitability',
    profitabilityValues: 'contractsView-contractsView_ccDepositConditionProfitabilityValues',
    profitabilitySameTinTaeValues: 'contractsView-contractsView_ccDepositConditionProfitabilitySameTinTaeValues',
    profitabilitySimpleValues: 'contractsView-contractsView_ccDepositConditionProfitabilityValuesSimple',
    account: 'contractsView-contractsView_ccDepositConditionAccount',
    applicationDate: 'contractsView-contractsView_ccDepositConditionApplicationDate',
    startDate: 'contractsView-contractsView_ccDepositConditionStartDate',
    expirationDate: 'contractsView-contractsView_ccDepositConditionExpirationDate',
    interestLiquidation: 'contractsView-contractsView_ccDepositConditionInterestLiquidation',
    interveners: 'contractsView-contractsView_ccDepositConditionInterveners',
    holders: 'contractsView-contractsView_ccDepositConditionHolders',
    authorized: 'contractsView-contractsView_ccDepositConditionAuthorized',
    liquidationType: 'contractsView-contractsView_ccDepositConditionInterestLiquidationType',
}

const WEB_POE_KEYS = {
    cancelInfo: 'contractsView-contractsView_depositConditionCancelInfo',
    product: 'contractsView-contractsView_depositConditionProduct',
    time: 'contractsView-contractsView_depositConditionTime',
    amount: 'contractsView-contractsView_depositConditionAmount',
    profitability: 'contractsView-contractsView_depositConditionProfitability',
    profitabilityValues: 'contractsView-contractsView_depositConditionProfitabilityValues',
    profitabilitySameTinTaeValues: 'contractsView-contractsView_depositConditionProfitabilitySameTinTaeValues',
    profitabilitySimpleValues: 'contractsView-contractsView_depositConditionProfitabilityValuesSimple',
    account: 'contractsView-contractsView_depositConditionAccount',
    applicationDate: 'contractsView-contractsView_depositConditionApplicationDate',
    startDate: 'contractsView-contractsView_depositConditionStartDate',
    expirationDate: 'contractsView-contractsView_depositConditionExpirationDate',
    interestLiquidation: 'contractsView-contractsView_depositConditionInterestLiquidation',
    interveners: 'contractsView-contractsView_depositConditionInterveners',
    holders: 'contractsView-contractsView_depositConditionHolders',
    authorized: 'contractsView-contractsView_depositConditionAuthorized',
    liquidationType: 'contractsView-contractsView_depositConditionInterestLiquidationType',
}

export const DepositRenovationInfo = ({
    onRenovationCancel,
    immRenovation,
    immAccounts,
    immDeposit,
    depositContractNumber,
    originCountry,
}) => {
    const { FormattedText, getLanguage } = i18n

    const poeKeys = __CONTACT_CENTER__
        ? CONTACT_CENTER_POE_KEYS
        : WEB_POE_KEYS

    const getFullDate = (date) => {
        return moment(date).locale(getLanguage()).format('LL')
    }

    const getIntervenersName = (interveners = [], role = []) => {
        return (interveners || [])
        .filter(intervener => role.includes(intervener.intervenerInterventionType) && intervener.intervenerName)
        .map(intervener => intervener.intervenerName.trim())
    }

    const handleRenovationCancel = () => {
        onRenovationCancel({
            accountContract: immRenovation.get('accountContract'),
            contractNumber: depositContractNumber
        })
    }

    const renderImpositions = () => (
        immRenovation.get('originalImpositions').map(imposition => {
            const plainAmountObject = getPlainAmountObject({
                amount: imposition.get('renewalAmount'),
                currency: "EUR"
            });

            const showFullValues = getIsFullProfitability(originCountry)

            const renewalAccount = immAccounts.get('byId').filter(account =>
                (account.get('contractNumber') === immDeposit.getIn(['impositionAssociatedAccount', 'contractNumber']) && 
                account.get('product') === immDeposit.getIn(['impositionAssociatedAccount', 'product']))).first()

            const depositInterveners = imposition.get('depositRenewalInterveners').toJS()
            const accountAlias = renewalAccount.get('alias')
            const shortIban = getLastNChars(renewalAccount.get('iban'), 4)

            const holders = getIntervenersName(depositInterveners, [INTERVENER_CODES.holder])
            const authorized = getIntervenersName(depositInterveners, [INTERVENER_CODES.authorized])
            const empowered = getIntervenersName(depositInterveners, [INTERVENER_CODES.empowered])

            const tin = formatInterest(imposition.get('renewalTin'))
            const tae = formatInterest(imposition.get('renewalTae'))

            const isSameTinTae = tin === tae
            const profitabilityFullValue = isSameTinTae ? poeKeys.profitabilitySameTinTaeValues : poeKeys.profitabilityValues;

            const injectedProfitabilityStrings = [
                tin,
                ...(showFullValues && !isSameTinTae ? [tae] : []),
            ]

            return(
                <React.Fragment key={imposition.get('originalImpositionNumber')}>
                    <div className="deposit-renovation-info__list">
                        <div className="deposit-renovation-info__item">
                            <FormattedText value={poeKeys.amount} />
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                className="deposit-renovation-info__item__value"
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                        </div>
                        <div className="deposit-renovation-info__item">
                            <FormattedText value={poeKeys.time} />
                            <span className="deposit-renovation-info__item__value">
                                <FormattedText
                                    value="contractsView-installmentValueKey"
                                    injectedStrings={[immRenovation.get('renewalDepositTermValue')]}
                                />
                            </span>
                        </div>

                        <div className="deposit-renovation-info__item">
                            <FormattedText value={poeKeys.profitability} />
                            <span className="deposit-renovation-info__item__value">
                                <FormattedText
                                    value={showFullValues ? profitabilityFullValue : poeKeys.profitabilitySimpleValues}
                                    injectedStrings={injectedProfitabilityStrings}
                                />
                            </span>
                        </div>

                        <div className="deposit-renovation-info__item">
                            <FormattedText value={poeKeys.account} />
                            <span className="deposit-renovation-info__item__value">
                                {accountAlias} {shortIban}</span>
                        </div>
                        <div className="deposit-renovation-info__item">
                            <FormattedText value={poeKeys.applicationDate} />
                            <span className="deposit-renovation-info__item__value"
                            >{getFullDate(imposition.get('requestDate'))}</span>
                        </div>

                        <div className="deposit-renovation-info__item">
                            <FormattedText value={poeKeys.startDate} />
                            <span className="deposit-renovation-info__item__value"
                            >{getFullDate(imposition.get('originalImpositionExpirationDate'))}</span>
                        </div>
                        <div className="deposit-renovation-info__item">
                            <FormattedText value={poeKeys.interestLiquidation} />
                            <span className="deposit-renovation-info__item__value">
                                <FormattedText value={poeKeys.liquidationType} />
                            </span>
                        </div>
                        
                        <div className="deposit-renovation-info__item">
                            <FormattedText value={poeKeys.interveners} />
                            {
                                holders.length > 0 && (
                                    <div className="deposit-renovation-info__subitem">
                                        <DepositInterveners role={poeKeys.holders} interveners={holders} />
                                    </div>
                                )
                            }
                            {
                                authorized.length > 0 && (
                                    <div className="deposit-renovation-info__subitem">
                                        <DepositInterveners role={poeKeys.authorized} interveners={authorized} />
                                    </div>
                                )
                            }
                            {
                                empowered.length > 0 && (
                                    <div className="deposit-renovation-info__subitem">
                                        <DepositInterveners role="contractsView-intervenerRepresentative" interveners={empowered} />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </React.Fragment>
        )})
    )
    
    return (
        <div className="deposit-renovation-info__row">
            {onRenovationCancel
                ?   (
                    <div
                        className="deposit-renovation-info__cancel-cc block-info"
                    >
                        <i className="block-info__icon-assistant"></i>
                        <FormattedText value={poeKeys.cancelInfo} />
                    </div>  
                )
                : (
                    <div className="deposit-renovation-info__cancel">
                        <FormattedText value={poeKeys.cancelInfo} />
                    </div>
                )
            }
            { renderImpositions() }
            {onRenovationCancel && (
                <div
                    className="deposit-renovation-info__cancel-action-cc block-info"
                    onClick={handleRenovationCancel}
                >
                    <i className="icon icon-informacion deposit-renovation-info__info-icon"></i>
                    <FormattedText value="contractsView-contractsView_ccDepositConditionActionCancel" />
                </div>  
            )}
        </div>
    )
}

DepositRenovationInfo.propTypes = {
    onRenovationCancel: PropTypes.func,
    depositsRenovationCancel: PropTypes.object,
    depositId: PropTypes.string,
    immRenovation: PropTypes.object,
    immAccounts: PropTypes.object,
    immDeposits: PropTypes.array,
    immDeposit: PropTypes.object,
    depositContractNumber: PropTypes.string,
    originCountry: PropTypes.string
};

module.exports.constructor = DepositRenovationInfo;
module.exports.DepositRenovationInfo = connect(
    state => ({
        depositsRenovationCancel: state.depositsRenovationCancel,
        originCountry: state.profile.get('originCountry'),
    }),
)(DepositRenovationInfo);